/* @flow */

import { ApiStore } from 'lib/api/django-restframework/api-store';
import JSONSerializable from 'lib/serialization/json-serializable';
import { observable } from 'mobx';
import { ApiStore as WPApiStore } from 'four-nets/api/wp-api-store';
import { UserStore, User } from 'four-nets/user/user';

@JSONSerializable()
class Base {}

export { Like };

@JSONSerializable()
class Like extends Base {
    @observable liker: User;
    @observable createdTime: Date;

    userStore: UserStore;

    constructor(options) {
        super(options);

        const { userStore } = options;
        this.userStore = userStore;
    }

    fromJSON({ json }) {
        const { liker: userJSON, createdTime, ...rest } = json;

        this.createdTime = new Date(createdTime);
        super.fromJSON({ json: rest });
        this.liker = this.userStore.processJSON({ json: userJSON });
    }
}

export class LikeStore extends ApiStore {
    constructor(options) {
        super(options);

        const { userStore } = options;
        this.delegate = this;
        this.userStore = userStore;
    }

    item() {
        return new Like({
            userStore: this.userStore,
            delegate: this,
        });
    }
}

export class WPLikeStore extends WPApiStore {
    constructor(options) {
        super(options);

        const { userStore } = options;
        this.delegate = this;
        this.userStore = userStore;
    }

    item() {
        return new Like({
            userStore: this.userStore,
            delegate: this,
        });
    }
}
